import React, { useEffect, useState } from 'react';
import { FaCommentDots } from 'react-icons/fa'; 
import '../styles/CardStyles.css';

function AverageCommentsPerPostCard() {
  const [averageComments, setAverageComments] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/data`);

        const data = await response.json();

        if (!data || !Array.isArray(data)) {
          console.error('Nenhum dado válido foi retornado da API');
          return;
        }

        let totalComments = 0;
        let totalPosts = data.length;

        data.forEach(post => {
          const comments = post._source.comentarios || [];
          totalComments += comments.length;
        });

        const average = totalComments / totalPosts;
        setAverageComments(average.toFixed(2)); 
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="card">
      <FaCommentDots size={40} color="#5a7302" className="card-icon" /> 
      <h3>Média de Comentários por Postagem</h3>
      <p>{averageComments}</p>
    </div>
  );
}

export default AverageCommentsPerPostCard;
